<template>
    <div class="molekule-siedetemperatur">
        <p>
            Je größer die Moleküloberfläche, desto größer die
            van-der-Waals-Kräfte, desto höher Schmelz-/Siedetemperatur
        </p>
    </div>
</template>

<script>
export default {
    name: 'molekule-siedetemperatur',
};
</script>
